import { useEffect } from "react";

export default function PalinsestoPage() {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta ? meta.getAttribute("content") : null;
    document.title = "Palinsesto AI · consulentIA.net";
    if (meta) {
      meta.setAttribute(
        "content",
        "Webinar, corsi, conferenze e dirette sull'intelligenza artificiale, aggiornati ogni settimana. Filtra per formato e argomento e aggiungi gli eventi al tuo calendario."
      );
    }

    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";

    const setHeaderVar = () => {
      const header = document.querySelector('[data-testid="main-navbar"]');
      const h = header ? Math.round(header.getBoundingClientRect().height) : 65;
      html.style.setProperty("--header-h", `${h}px`);
    };
    setHeaderVar();
    window.addEventListener("resize", setHeaderVar);

    return () => {
      document.title = prevTitle;
      if (meta && prevDesc !== null) meta.setAttribute("content", prevDesc);
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      html.style.removeProperty("--header-h");
      window.removeEventListener("resize", setHeaderVar);
    };
  }, []);

  return (
    <main className="bg-[#0A0A0A]" data-testid="palinsesto-page">
      <iframe
        src="https://palinsesto.consulentia.net/"
        title="Palinsesto AI"
        allow="clipboard-write"
        referrerPolicy="strict-origin-when-cross-origin"
        className="palinsesto-iframe block w-full border-0 bg-[#0A0A0A]"
        data-testid="palinsesto-iframe"
      />
    </main>
  );
}
